import { LEVEL_TYPE } from "api/interfaces/commonInterface.interface";
import { SubscriptionPageOutletContext } from "api/interfaces/subscription.interface";
import { useOutletContext } from "react-router-dom";
import { useAppSelector } from "redux/hooks";
import SubscriptionKeyHistory from "./SubscriptionKeyHistory";
import SubscriptionUsageHistory from "./SubscriptionUsageHistory";
import { useMemo } from "react";

export default function SubscriptionHistoryRoute(): JSX.Element {
  const { accountLevel, isUsagePaid } = useAppSelector(
    (state) => state.accountSettings
  );
  const { selectedRowAccount } =
    useOutletContext<SubscriptionPageOutletContext>();

  const isUsageHistory = useMemo(() => {
    if (accountLevel !== LEVEL_TYPE.EU && selectedRowAccount) {
      return selectedRowAccount.isUsagePaid;
    }
    return isUsagePaid;
  }, [selectedRowAccount, accountLevel, isUsagePaid]);

  if (isUsageHistory) {
    return <SubscriptionUsageHistory />;
  }

  return <SubscriptionKeyHistory />;
}
